import { Box, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const FilterItem = ({ children, label, onClear }: {
  children: JSX.Element,
  onClear?: () => void;
  label: string;
}) => {

  const { t } = useTranslation();

  return (
    <Box display="flex" flexDirection="column" pr={2} pl={2} gap={1}>
      <Box display="flex" justifyContent="space-between" alignItems="flex-start" alignSelf="stretch">
        <Typography variant="body2" gutterBottom={false}>{label}</Typography>
        {onClear && <Link color="error" underline="hover" onClick={onClear}>{t('filters.clear')}</Link>}
      </Box>
      {children}
    </Box>
  );
};
